module.exports = __webpack_public_path__ + "static/img/TP_logo.2919b599.png";